import {
  GET_VEHICLE_PERSPECTIVES_SUCCESS,
  GET_WORKSHOP_SEGMENTS_SUCCESS,
  GET_DAMAGE_TYPES_SUCCESS,
  GET_BODY_DAMAGE_TYPES_SUCCESS,
  CLEAR_DAMAGE_TYPES,
  CLEAR_BODY_DAMAGE_TYPES_SUCCESS,
  SAVE_SELECTED_PART_ID,
  SAVE_ORIENTATION,
  GET_LIST_OF_WORKSHOPS_SUCCESS,
  LOGOUT_SUCCESS,
  GET_GLOBAL_SETTINGS_SUCCESS,
} from "../Types";

const initalState = {
  workshopSegments: [],
  vehiclePerspectives: [],
  damageTypes: [],
  bodyDamageType: [],
  selectedPartDetails: {},
  orientation: {},
  listOfWorkshops: [],
  globalSettings: [],
};

export function workShopReducer(state = initalState, action) {
  switch (action.type) {
    case GET_WORKSHOP_SEGMENTS_SUCCESS: {
      return {
        ...state,
        workshopSegments: action.body.data,
      };
    }
    case GET_VEHICLE_PERSPECTIVES_SUCCESS: {
      return {
        ...state,
        vehiclePerspectives: action.body.data,
      };
    }
    case GET_DAMAGE_TYPES_SUCCESS: {
      return {
        ...state,
        damageTypes: action.body.data,
      };
    }
    case GET_BODY_DAMAGE_TYPES_SUCCESS: {
      return {
        ...state,
        bodyDamageType: action.body.data,
      };
    }
    case CLEAR_DAMAGE_TYPES: {
      return {
        ...state,
        damageTypes: [],
      };
    }
    case CLEAR_BODY_DAMAGE_TYPES_SUCCESS: {
      return {
        ...state,
        bodyDamageType: [],
      };
    }
    case SAVE_SELECTED_PART_ID: {
      return {
        ...state,
        selectedPartDetails: action.data,
      };
    }
    case SAVE_ORIENTATION: {
      return {
        ...state,
        orientation: action.data,
      };
    }
    case GET_LIST_OF_WORKSHOPS_SUCCESS: {
      return {
        ...state,
        listOfWorkshops: action.body.data,
      };
    }
    case GET_GLOBAL_SETTINGS_SUCCESS: {
      return {
        ...state,
        globalSettings: action.body.data,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initalState };
    }
    default:
      return state;
  }
}
